module.exports = __webpack_public_path__ + "img/quanxian.f20310d7.png";